module.exports = __webpack_public_path__ + "static/media/Grades-Illustration.0637390e.svg";